<template>
  <div class="hri-dashboard">
    <div class="mt-20 mb-30 text-left overview-header">
      <h4 class="font-web">Overview</h4>
      <div class="header-actions">
        <a-button icon="dashboard" class="header-btn" href="https://newmy.muic.io/organization-data" target="_blank" rel="noopener noreferrer">
          HR Dashboard
        </a-button>
        <a-button icon="deployment-unit" class="header-btn"
          @click="openDrawer('Human Resources Section Organize Chart and Job Responsibilities', 'deployment-unit')">
          HR Organize Chart
        </a-button>
        <a-button icon="file" class="header-btn" @click="openDrawer('Documents & Certificates', 'notification')">
          Documents
        </a-button>
        <a-button icon="user" class="header-btn" @click="$router.push('/profile')">
          MY PROFILE
        </a-button>
      </div>
    </div>

    <!-- Second Row: Job Ads, Donut Chart, Account -->
    <a-row type="flex" :gutter="[16, 16]" class="content-row">

      <!-- Right: Account & Access -->
      <a-col :xs="24" :lg="isStaff && !isAcademicStaff ? 8 : 24" class="dashboard-overview-col">
        <a-card :bordered="false" class="account-card">
          <div class="stat-content overview-stat-content width-100">
            <div class="overview-card-header mb-10 flex-between-center">
              <div class="flex-start-center">
                <a-avatar shape="square" :size="64" src="/images/hri_dashboard/leave_history.png" class="mr-15" />
                <div class="header-main-text">
                  <h5 class="stat-title-text overview-stat-title mb-0 text-dark">Leave Quota</h5>
                  <p class="font-web mb-0 prominent-date secondary-text">
                    Annual Leave Quota {{ currentYear }}
                  </p>
                </div>
              </div>
              <a-button size="small" class="btn-view-all" @click="$router.push('/hri/leaveofabsence')">VIEW
                ALL</a-button>
            </div>
            <SummaryLeave :leaveSummary="leaveSummary" :vacationLimit="vacationQuota" :casualLimit="casualQuota"
              :loading="loading" />
          </div>
          <div class="leave-card-footer mt-auto pt-15">
            <small class="text-muted">
              Read more notices about the requirements for each type of leave.
              <a class="ml-5" target="_blank" rel="noopener noreferrer"
                href="https://drive.google.com/file/d/17zqcS6zDJ1nDnEMjRJJLOPqaU_k-lGvR/view?usp=sharing">Click
                Here</a>
            </small>
            <small class="text-muted d-block">
              If you have questions, please do not hesitate to contact me by this email
              <a href="mailto:yanin.som@mahidol.ac.th">yanin.som@mahidol.ac.th</a>
            </small>
          </div>
        </a-card>
      </a-col>

      <!-- Center: Total Overview Gauge -->
      <a-col v-if="isStaff && !isAcademicStaff" :xs="24" :lg="8" class="dashboard-overview-col">
        <a-card :bordered="false" class="overview-card">
          <div class="detailed-stat-card-body mb-10 overview-stat-body">
            <div class="stat-content overview-stat-content width-100">
              <div class="overview-card-header mb-0 flex-between-center">
                <div class="flex-start-center">
                  <a-avatar shape="square" :size="64" src="/images/hri_dashboard/late_arrival.png"
                    class="stat-avatar-img mr-15" />
                  <div class="header-main-text">
                    <h5 class="stat-title-text overview-stat-title mb-0 text-dark">สรุปข้อมูลการทำงานสาย</h5>
                    <p class="font-web mb-0 prominent-date secondary-text">
                      ประจำเดือน {{ moment().add(543, 'year').locale('th').format('MMMM YYYY') }}
                    </p>
                  </div>
                </div>
                <a-button size="small" class="btn-view-all mr-10"
                  @click="openDrawer('สรุปข้อมูลการทำงานสาย', '/images/hri_dashboard/late_arrival.png')">ACCESS
                  ALL</a-button>
                <a-button size="small" class="btn-view-all"
                  @click="$router.push('/profile-overview')">Overview</a-button>
              </div>
            </div>
          </div>

          <div class="chart-wrapper">
            <vue-gauge class="late-gauge" :key="'gauge_' + gaugeKey"
              :refid="'gauge_' + Math.random().toString(36).substr(2, 9)" :options="gaugeOptions" />
            <a-row type="flex" justify="center" class="late-stats-row">
              <div class="stat-box">
                <a-statistic title="จำนวนครั้งที่ขาดงาน" :value="lateArrivalData.sum_absent" />
              </div>
              <div class="stat-box" :style="lateStatStyle">
                <a-statistic title="จำนวนนาทีการมาสาย" :value="lateArrivalData.totalLateMin" />
              </div>
            </a-row>
          </div>
        </a-card>
      </a-col>

      <!-- Left: Your Job Ads -->
      <a-col v-if="isStaff && !isAcademicStaff" :xs="24" :lg="8" class="dashboard-overview-col">
        <a-card :bordered="false" class="job-ads-card">
          <div class="detailed-stat-card-body mb-10 overview-stat-body">
            <div class="stat-content overview-stat-content width-100">
              <div class="overview-card-header mb-0 flex-between-center">
                <div class="flex-start-center">
                  <a-avatar shape="square" :size="64" src="/images/hri_dashboard/request_list.png"
                    class="stat-avatar-img mr-15" />
                  <div class="header-main-text">
                    <h5 class="stat-title-text overview-stat-title mb-0 text-dark">รายการคำขอ</h5>
                    <p class="font-web mb-0 prominent-date secondary-text">
                      ประจำเดือน {{ currentMonthThai }}
                    </p>
                  </div>
                </div>
                <a-button size="small" class="mr-10 btn-view-all"
                  @click="openDrawer('รายการคำขอ', '/images/hri_dashboard/request_list.png')">VIEW ALL</a-button>
                <a-button size="small" type="primary" class="btn-create-job" @click="$router.push('/hri/request')">
                  <a-icon type="edit" /> เขียนคำขอ
                </a-button>
              </div>
            </div>
          </div>
          <SummaryRequest :requests="requestList" :loading="loading" @delete="handleDeleteRequest" />
        </a-card>
      </a-col>
    </a-row>

    <!-- HRD Budget Summary Card -->
    <!--  
    <a-card
      v-if="$store.state.role && $store.state.role.RulesUser && $store.state.role.RulesUser.username && $store.state.role.RulesUser.username.split('.').length === 2"
      :bordered="true" :style="{ border: '1px solid #2B2A4C' }" class="dashboard-bar-chart mb-20 mt-20">
      <a-row type="flex">
        <a-col class="col-content" :span="24" :xl="12" :sm="24">
          <div class="card-content">
            <h4 class="f-500 mb-0 font-web font-weight-bold">
              <a-icon type="file-protect" class="mr-5" />สรุปข้อมูลการใช้งบ HRD Budget
            </h4>
          </div>
        </a-col>
        <a-col class="col-img text-right" :span="24" :xl="12" :sm="24">
          <a-select class="mt-0 mb-10 text-center" v-model="yearHrd" :default-value="yearHrd" style="width: 100%;"
            @change="onChangeHrdYear">
            <a-select-option :value="parseInt(moment().format('YYYY'))">
              <span :style="{ fontWeight: 'bold' }" class="ml-10 mr-10 font-web font-weight-bold">
                {{ parseInt(moment().format("YYYY")) }}
              </span>
            </a-select-option>
            <a-select-option v-for="i in 3" :key="'option' + i" :value="parseInt(moment().format('YYYY')) - i">
              <span :style="{ fontWeight: 'bold' }" class="ml-10 mr-10 font-web font-weight-bold">
                {{ parseInt(moment().format("YYYY")) - i }}
              </span>
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>

      <div class="mt-20 mb-20">
        <a-row type="flex">
          <a-col class="col-content text-center" :span="6" :xl="6" :sm="24">
            <div>
              <a-progress :strokeWidth="15" type="dashboard" :percent="hrd_budget_sum_use_percent" :stroke-color="{
                '0%': '#420a4b',
                '50%': '#580d65',
                '90%': '#6e117e',
                '100%': '#841497',
              }" />
            </div>
          </a-col>
          <a-col class="col-img text-left" :span="18" :xl="18" :sm="24">
            <a-statistic
              :title="`Budget Report maximum ${checkManage ? '150,000' : ($store.state.role && $store.state.role.RulesUser && $store.state.role.RulesUser.roles && $store.state.role.RulesUser.roles.indexOf('staff') >= 0 ? '20,000' : '25,000')} baht / person`"
              :value="hrd_budget_sum_use" style="margin-right: 50px" />
            <div>
              <a-space>
                <span class="font-web">Total Request 9 request</span>
                <span class="font-web">Total Budget request in year 01 / Oct / {{ parseInt(yearHrd) - 1 }} to 31 / Sep /
                  {{ parseInt(yearHrd) }}</span>
              </a-space>
            </div>
          </a-col>
        </a-row>
      </div>
      <p class="f-500 font-web mt-10 mb-0 text-muted" style="font-size: 12px">
        ข้อมูลที่แสดง
        เป็นเพียงข้อมูลเบื้องต้นเท่านั้นหากต้องการทราบรายละเอียด โปรดติดต่อ hr
        อีกครั้ง
      </p>
    </a-card>
    -->

    <div class="mt-50 mb-30 text-left">
      <h4 class="font-web">Service HR-Intelligent</h4>
    </div>

    <!-- Top Row: Detailed Category Cards -->
    <a-row type="flex" :gutter="[16, 16]" class="stat-cards-row">
      <a-col :xs="24" :sm="12" :md="12" :lg="8" v-for="(stat, idx) in statCards" :key="idx">
        <a-card :bordered="false" class="detailed-stat-card">
          <div class="detailed-stat-card-body">
            <div class="stat-illustration">
              <img :src="stat.image" :alt="stat.title" class="undraw-img" />
            </div>
            <div class="stat-content">
              <h3 class="stat-title-text">{{ stat.title }}</h3>
              <ul class="stat-details-list">
                <li v-for="(detail, dIdx) in stat.details" :key="dIdx">
                  <a-icon type="right-circle" theme="filled" class="detail-bullet" />
                  {{ detail }}
                </li>
              </ul>
            </div>
          </div>
          <div class="stat-footer">
            <div v-if="stat.disabled" class="stat-link disabled">
              Coming Soon <a-icon type="lock" />
            </div>
            <a v-else-if="stat.externalLink" :href="stat.externalLink" target="_blank" rel="noopener noreferrer" class="stat-link">
              More Info <a-icon type="arrow-right" />
            </a>
            <a v-else href="javascript:;" class="stat-link"
              @click="stat.route ? $router.push(stat.route) : openDrawer(stat.title, stat.image)">
              More Info <a-icon type="arrow-right" />
            </a>
          </div>
        </a-card>
      </a-col>
    </a-row>


    <MainModal :visible="isDrawerVisible" :title="drawerTitle" :icon="drawerIcon" :contract-name-eng="contractNameEng" @close="isDrawerVisible = false">
    </MainModal>
  </div>
</template>

<script>
import MainModal from './portalcomponents/mainmodal.vue';
import SummaryLeave from './portalcomponents/summaryleave.vue';
import SummaryRequest from './portalcomponents/summaryrequest.vue';
import VueGauge from "vue-gauge";
import moment from "moment";
import "moment/locale/th";

export default {
  components: { MainModal, SummaryLeave, SummaryRequest, VueGauge },
  data() {
    return {
      isDrawerVisible: false,
      drawerTitle: '',
      drawerIcon: '',
      statCards: [
        {
          title: 'Request Form',
          details: ['Leave of Absence Form', 'Development Forms', 'Welfare Forms', 'Others'],
          image: '/images/hri_dashboard/request_form.png',
          route: '/hri/request'
        },
        {
          title: 'On-boarding',
          details: ['New Employee Guidelines', 'Orientation Timetable', 'MUIC Core Values', 'HR น่ารู้'],
          image: '/images/hri_dashboard/onboarding.png'
        },
        {
          title: 'Financial Compensation',
          details: ['Salary & Payslip (e-Payroll)', 'Income Tax', 'Others'],
          image: '/images/hri_dashboard/finance.png'
        },
        {
          title: 'Welfare & Benefits',
          details: ['Welfare Allowance', 'Group Insurance', 'Children’s Scholarship', 'Provident Fund', 'Social Security', 'Other'],
          image: '/images/hri_dashboard/welfare.png',
        },
        {
          title: 'Performance Management',
          details: ['Performance Evaluation Process', 'IDP Process', 'Others'],
          image: '/images/hri_dashboard/performance.png',
        },
        {
          title: 'Performance Management Guideline for Division Chairs',
          details: ['Performance Management Guideline for Division Chairs'],
          image: '/images/hri_dashboard/performance_chair.png',
        },
        {
          title: 'Learning & Development',
          details: ['HRD Budget Guideline', 'Developmental Roadmap', 'IDP Essential', 'Career Growth'],
          image: '/images/hri_dashboard/learning.png'
        },
        {
          title: 'VISA & Work Permit',
          details: ['VISA', 'Work Permit', '90 Days Report'],
          image: '/images/hri_dashboard/visa.png',
        },
        {
          title: 'Documents & Certificates',
          details: ['Regulations', 'Announcements'],
          image: '/images/hri_dashboard/regulations.png'
        },
        {
          title: 'HR Dashboards',
          details: ['Workforce Overview'],
          image: '/images/hri_dashboard/dashboards.png',
          disabled: true
        },
        {
          title: 'Retirement Information',
          details: ['Re-Engagement after The Age of 60 (Academic Staff)'],
          image: '/images/hri_dashboard/retirement.png',
        },
      ],
      jobAds: [
        { title: 'Investment ESG Analyst', dept: 'W1', newCount: 185, waiting: 0, total: 250 },
        { title: 'Finance Analyst', dept: 'W1', newCount: 120, waiting: 20, total: 180 },
        { title: 'Marketing Specialist', dept: 'W1', newCount: 140, waiting: 15, total: 210 },
        { title: 'Software Engineer', dept: 'W1', newCount: 135, waiting: 35, total: 200 },
      ],
      lateMinute: 185,
      moment: moment,
      lateArrivalData: {
        year: moment().year(),
        month: moment().month() + 1,
        sum_mount: 0,
        sum_absent: 0,
        sum_leave: 0,
        cal_absent: 0,
        totalLateMin: 0,
      },
      requestList: {
        wait: [],
        approve: [],
        reject: [],
        cancel: []
      },
      leaveSummary: null,
      vacationQuota: 0,
      casualQuota: 0,
      currentYear: moment().year(),
      loading: false,
      gaugeKey: 0,
      gaugeOptions: {
        chartWidth: '320',
        outerNeedle: true,
        needleValue: 0,
        needleColor: "#27005D",
        arcDelimiters: [50, 83.33], // 180/360 * 100 = 50, 300/360 * 100 = 83.33
        arcColors: ["#fef100", "#FD8D14", "#C70039"],
        arcLabels: ['180 นาที', ''],
        rangeLabel: ['0 นาที', 'มากกว่า 300 นาที'],
        centralLabel: '0',
        rangeLabelFontSize: 13,
        labelsFont: 'Inter',
      },
      // HRD Budget
      yearFormat: "YYYY",
      yearHrd: moment().format('YYYY'),
      hrd_budget_sum_use: 0,
      hrd_budget_sum_use_percent: 0,
      checkManage: false,
      selectMonth: moment().format(),
      monthFormat: "MMMM/YYYY",
      data: [],
      dataSum: [],
      dataDetailLog: [],
      spinA: false,
      baseProfile: null,
      dataBaseProfile: [],
      contractNameEng: '',
    };
  },
  computed: {
    lateStatStyle() {
      const val = this.lateArrivalData.totalLateMin || 0;
      let bgColor = '#f8f9fa'; // Default grey for 0
      let textColor = '#8c8c8c'; // Default label color
      let contentColor = '#1a1a2e'; // Default content color

      if (val === 0) {
        bgColor = '#f8f9fa';
      } else if (val <= 180) {
        bgColor = '#fef100';
        textColor = '#000000';
        contentColor = '#000000';
      } else if (val <= 300) {
        bgColor = '#FD8D14';
        textColor = '#ffffff';
        contentColor = '#ffffff';
      } else {
        bgColor = '#C70039';
        textColor = '#ffffff';
        contentColor = '#ffffff';
      }

      return {
        background: bgColor,
        '--stat-label-color': textColor,
        '--stat-content-color': contentColor,
        transition: 'all 0.3s ease'
      };
    },
    currentMonthThai() {
      return moment().locale('th').add(543, 'year').format('MMMM YYYY');
    },
    isStaff() {
      const { RulesUser } = this.$store.state.role || {};
      return RulesUser && RulesUser.roles && RulesUser.roles.includes('staff');
    },
    isAcademicStaff() {
      if (!this.contractNameEng) return false;
      return this.contractNameEng.trim().toLowerCase() === 'full-time academic staff';
    },
    isSupportingStaff() {
      if (!this.contractNameEng) return false;
      return this.contractNameEng.trim().toLowerCase() === 'full-time supporting staff';
    }
  },
  mounted() {
    this.fetchLeaveData();
    this.fetchLateArrivalData();
    this.fetchRequestListData();
    this.getBaseProfile();
    this.getProfileManage();
    this.getBudgetSummary();
  },
  methods: {
    openDrawer(title, icon) {
      this.drawerTitle = title;
      this.drawerIcon = icon;
      this.isDrawerVisible = true;
    },
    async fetchLeaveData() {
      this.loading = true;
      try {
        const resYear = await this.$http.get('/hri/leave_of_absence/view_year/');
        if (resYear.status === 200 && resYear.data.length > 0) {
          const years = resYear.data.map((item) => item.year).sort((a, b) => b - a);
          const latestYear = years[0];
          this.currentYear = latestYear;

          const [resCasual, resSummary, resVacation] = await Promise.all([
            this.$http.get(`/hri/vacation_quota/casual/?year=${latestYear}`),
            this.$http.get(`/hri/leave_of_absence/summary_absence/?year=${latestYear}`),
            this.$http.get(`/hri/vacation_quota/?year=${latestYear}`),
          ]);

          if (resCasual.status === 200) {
            this.casualQuota = resCasual.data.casual_quota;
          }
          if (resSummary.status === 200) {
            this.leaveSummary = resSummary.data;
          }
          if (resVacation.status === 200 && resVacation.data.length > 0) {
            this.vacationQuota = resVacation.data[0].quota;
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching leave data:', error);
        this.leaveSummary = { vacation: 0, sick: 0, medical: 0, extra: 0, casual: 0 };
        this.vacationQuota = 0;
        this.casualQuota = 0;
      } finally {
        this.loading = false;
      }
    },
    async fetchRequestListData() {
      try {
        const start = moment().startOf('month').format('YYYY-MM-DD');
        const end = moment().endOf('month').format('YYYY-MM-DD');

        const [resFlex, resLeave, resWFH, resTime, resSeminar] = await Promise.all([
          this.$http.get(`/hri/flexible-day/me/?start=${start}&end=${end}`),
          this.$http.get(`/hri/leave_of_absence/?timestart=${start}&timeend=${end}`),
          this.$http.get(`/hri/workfromhome/me/?start=${start}&end=${end}`),
          this.$http.get(`/hri/time-request/?timestart=${start}&timeend=${end}`),
          this.$http.get(`/hri/seminar-request/?timestart=${start}&timeend=${end}`)
        ]);

        let allRequests = [];

        const formatThai = (d) => `<b>${moment(d).add(543, 'year').locale('th').format('DD/MM/YYYY')}</b>`;

        if (resFlex.status === 200 && Array.isArray(resFlex.data)) {
          allRequests = allRequests.concat(resFlex.data.map(item => ({
            id: item.id,
            type: 'flex',
            title: 'Flexible Day',
            subtitle: `${formatThai(item.selected_date)} แลกกับ ${formatThai(item.move_to_date)}`,
            status: item.status,
            icon: 'swap'
          })));
        }

        if (resLeave.status === 200 && Array.isArray(resLeave.data)) {
          allRequests = allRequests.concat(resLeave.data.map(item => ({
            id: item.id,
            type: 'leave',
            title: item.absence_type.charAt(0).toUpperCase() + item.absence_type.slice(1),
            subtitle: `${formatThai(item.start_date)} ถึง ${formatThai(item.end_date)} รวมลา <b>${item.absence_amount}</b> วัน`,
            status: item.status,
            icon: 'schedule'
          })));
        }

        if (resWFH.status === 200 && Array.isArray(resWFH.data)) {
          allRequests = allRequests.concat(resWFH.data.map(item => ({
            id: item.id,
            type: 'home',
            title: 'Work From Home',
            subtitle: `วันที่ ${formatThai(item.selected_date)}`,
            status: item.status,
            icon: 'home'
          })));
        }

        if (resTime.status === 200 && Array.isArray(resTime.data)) {
          allRequests = allRequests.concat(resTime.data.map(item => {
            const startTime = item.start_time ? moment(item.start_time).format('HH:mm') : '-';
            const endTime = item.end_time ? moment(item.end_time).format('HH:mm') : '-';
            const displayDate = item.start_time || item.end_time || null;

            return {
              id: item.id,
              type: 'time',
              title: 'Time Absent',
              subtitle: `วันที่ ${displayDate ? formatThai(displayDate) : '-'} เวลา ${startTime} - ${endTime}`,
              status: item.status,
              icon: 'clock-circle'
            };
          }));
        }

        if (resSeminar.status === 200 && Array.isArray(resSeminar.data)) {
          allRequests = allRequests.concat(resSeminar.data.map(item => ({
            id: item.id,
            type: 'serminar',
            title: `Serminar Type ${item.seminar_type}`,
            subtitle: `${formatThai(item.start_date)} ถึง ${formatThai(item.end_date)} รวม <b>${item.seminar_amount}</b> วัน`,
            status: item.status,
            icon: 'reconciliation'
          })));
        }

        const grouped = {
          wait: [],
          approve: [],
          reject: [],
          cancel: []
        };

        allRequests.forEach(req => {
          if (grouped[req.status]) {
            grouped[req.status].push(req);
          }
        });

        this.requestList = grouped;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching request list:', error);
      }
    },
    async handleDeleteRequest(parampath) {
      this.loading = true;
      try {
        const res = await this.$http.delete(parampath);
        if (res.status === 200) {
          this.$notification.success({
            message: 'สำเร็จ',
            description: 'ลบคำขอเรียบร้อยแล้ว',
          });
          await this.fetchRequestListData();
        }
      } catch (error) {
        console.error('Error deleting request:', error);
        this.$notification.error({
          message: 'ข้อผิดพลาด',
          description: 'ไม่สามารถลบคำขอได้ โปรดลองอีกครั้ง',
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchLateArrivalData() {
      try {
        const timestart = moment().startOf('month').format('YYYY-MM-DD');
        const timeend = moment().endOf('month').format('YYYY-MM-DD');
        const res = await this.$http.get(`/hri/time_attendance/view_year/?timestart=${timestart}&timeend=${timeend}`);

        if (res.status === 200) {
          const data = res.data;
          let totalLateMin = 0;
          if (data.detail && Array.isArray(data.detail)) {
            totalLateMin = data.detail.reduce((sum, item) => sum + parseFloat(item.sum_min || 0), 0);
          }

          this.lateArrivalData = {
            ...data,
            totalLateMin
          };

          // Update gauge options
          this.gaugeOptions = {
            ...this.gaugeOptions,
            needleValue: Math.min((totalLateMin / 360) * 100, 100),
            centralLabel: totalLateMin.toString()
          };

          this.gaugeKey++;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching late arrival data:', error);
      }
    },
    async onChange(value, dateString) {
      this.getSummaryData();
    },
    onChangeHrdYear(value, dateString) {
      this.getBudgetSummary();
    },
    async getBudgetSummary() {
      try {
        const res = await this.$http.get(
          `/hri/seminar-request/budget-summary/?year=${this.yearHrd}`
        );
        if (res.status === 200 && res.data) {
          const val = Number.parseFloat(res.data.hrd_budget_sum_use) || 0;
          this.hrd_budget_sum_use = val.toFixed(2);
          this.hrd_budget_sum_use_percent = (val * 100) / 20000;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.notiErrorApi(
          `/hri/seminar-request/budget-summary/?year=2025`,
          error.response ? error.response.status : error.message
        );
      }
    },

    async getSummaryData() {
      this.data = [];
      this.dataSum = [];
      this.dataDetailLog = [];
      this.spinA = true;

      const x = new Date(this.selectMonth);
      let month = Number.parseInt(x.getMonth()) + Number.parseInt(1);
      let year = x.getFullYear();
      let formatMount = this.formatMonth(month);
      let startMonth =
        year + "-" + `${formatMount}` + "-" + this.getDayInFirst(month, year);
      let endMonth =
        year + "-" + formatMount + "-" + this.getDayInLast(month, year);

      try {
        const res = await this.$http.get(
          `/hri/time_attendance/view_year/?timestart=${startMonth}&timeend=${endMonth}`
        );
        if (res.status === 200) {
          this.dataDetailLog = (res.data && res.data.detail) || [];
          if (res.data) {
            this.dataSum.push(res.data);
          }
          this.spinA = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataSum = [];
        this.dataDetailLog = [];
        this.spinA = false;
        this.notiErrorApi(
          `/hri/time_attendance/view_year/?timestart=${startMonth}&timeend=${endMonth}`,
          error.response ? error.response.status : error.message
        );
      }
    },

    // check amount Bud
    isEmpty(obj) {
      if (!obj) return true;
      return Object.keys(obj).length === 0;
    },
    async getBaseProfile() {
      try {
        const resBaseProfile = await this.$http.get(`/staff/profile/me/`);
        if (resBaseProfile.status === 200) {
          this.baseProfile = resBaseProfile.data;
          this.dataBaseProfile = [resBaseProfile.data];
          this.contractNameEng = (resBaseProfile.data && resBaseProfile.data.contract && resBaseProfile.data.contract.name_eng) || '';
          return resBaseProfile.data;
        } else {
          const error = new Error('Request Failed');
          error.resBaseProfile = resBaseProfile;
          error.response = resBaseProfile;
          throw error;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching base profile:', error);
      }
    },
    async getProfileManage() {
      try {
        const res = await this.$http.get(`/staff/profile/management/`);
        if (res.status === 200) {
          this.checkManage = !this.isEmpty(res.data);
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        // Handle error silently
      }
    },
    formatMonth(val) {
      return val.toString().length === 1 ? "0" + val.toString() : val.toString();
    },
    getDayInFirst(month, year) {
      return new Date(year, month, 1).getDate().toString().length === 1
        ? "0" + new Date(year, month, 1).getDate()
        : new Date(year, month, 1).getDate();
    },
    getDayInLast(month, year) {
      return new Date(year, month, 0).getDate().toString().length === 1
        ? "0" + new Date(year, month, 0).getDate()
        : new Date(year, month, 0).getDate();
    },
    disableMonth(date) {
      if (
        this.moment(date).format("MM") <= "10" &&
        this.moment(date).format("YYYY") <= 2022
      ) {
        return true;
      }
      return false;
    },
    notiErrorApi(url, data) {
      this.$notification.open({
        style: {
          backgroundColor: "#ff1919",
          color: "#ffffff",
        },
        message: function (h) {
          return h("div", [
            h("strong", { class: "font-web" }, `Error ${data}`),
          ]);
        },
        description: `Problem issue connect api : ${url}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hri-dashboard {
  padding: 0;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    margin: 0;
  }

  .header-actions {
    display: flex;
    gap: 12px;
  }

  .header-btn {
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    color: #1a1a2e;
    font-size: 14px;
    font-weight: 600;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    padding: 0 16px;
    gap: 8px;

    &:hover {
      background: #1a1a2e;
      color: #ffffff;
      transform: translateY(-2px);
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .header-actions {
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    .header-btn {
      flex: 1 1 auto;
      min-width: calc(33.333% - 12px);
      font-size: 12px;
      padding: 0 12px;
    }
  }

  @media (max-width: 576px) {
    .header-btn {
      min-width: calc(50% - 12px);
    }
  }
}

.stat-cards-row {
  margin-bottom: 50px;

  .ant-col {
    display: flex;
    flex-direction: column;
  }
}

/* ── Detailed Category Cards ── */
.detailed-stat-card {
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  background: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }

  &::v-deep .ant-card-body {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .detailed-stat-card-body {
    display: flex;
    gap: 16px;
    flex: 1;
    align-items: center;

    @media (max-width: 576px) {
      flex-direction: column;
      text-align: center;
      gap: 12px;
    }
  }

  .stat-illustration {
    flex: 0 0 100px;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .undraw-img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .stat-content {
    flex: 1;
  }

  .stat-title-text {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 12px;
    line-height: 1.3;
  }

  .stat-details-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 13px;
      color: #595959;
      margin-bottom: 6px;
      display: flex;
      align-items: flex-start;
      line-height: 1.4;

      .detail-bullet {
        font-size: 12px;
        color: #1a1a2e;
        margin-right: 8px;
        margin-top: 3px;
        opacity: 0.7;
      }
    }
  }

  .stat-footer {
    margin-top: auto;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
  }

  .stat-link {
    font-size: 13px;
    color: #1a1a2e;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      color: #4285F4;
    }

    &.disabled {
      color: #bfbfbf;
      cursor: not-allowed;

      &:hover {
        color: #bfbfbf;
      }
    }
  }
}

/* ── Section Common ── */
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 16px;
}

.content-row {
  .dashboard-overview-col {
    display: flex;
    flex-direction: column;

    .ant-card {
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      height: 100%;
      display: flex !important;
      flex-direction: column;

      &::v-deep .ant-card-body {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

/* ── Job Ads ── */
.job-ads-card {
  .job-ads-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
  }

  .job-ads-actions {
    display: flex;
    gap: 8px;
  }

  .btn-view-all {
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
  }

  .btn-create-job {
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
    background: #1890ff;
    border-color: #1890ff;
  }
}

.job-ads-list {
  .job-ads-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .job-info {
    display: flex;
    flex-direction: column;
  }

  .job-title {
    font-weight: 600;
    font-size: 14px;
    color: #1a1a2e;
  }

  .job-dept {
    font-size: 12px;
    color: #b0b0b0;
    margin-top: 2px;
  }

  .job-stats {
    display: flex;
    gap: 20px;
    text-align: center;
  }

  .job-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .job-stat-value {
    font-size: 15px;
    font-weight: 700;
    color: #1a1a2e;
  }

  .job-stat-total {
    color: #4285F4;
  }

  .job-stat-label {
    font-size: 11px;
    color: #b0b0b0;
    margin-top: 2px;
  }
}

.overview-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;

  .stat-title-text {
    margin-bottom: 0;
  }
}

/* ── Overview Gauge ── */
.overview-card {
  .overview-stat-body {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    .stat-avatar-img {
      margin-top: 4px;
    }
  }

  .overview-stat-content {
    flex: 1;

    .overview-stat-title {
      margin-bottom: 0;
      font-size: 15px;
    }

    .prominent-date {
      font-size: 16px;
      color: #1a1a2e;
      font-weight: 800;
      margin-bottom: 10px;
    }
  }

  .chart-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    .late-gauge {
      font-size: 12px;
      font-weight: 900;
    }
  }

  .late-stats-row {
    margin: 10px 0 5px;
    gap: 24px;

    .stat-box {
      background: #f8f9fa;
      padding: 10px 24px;
      border-radius: 12px;
      min-width: 120px;
      text-align: center;

      ::v-deep .ant-statistic-title {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: var(--stat-label-color, #8c8c8c);
        margin-bottom: 2px;
        font-weight: 600;
        transition: color 0.3s ease;
      }

      ::v-deep .ant-statistic-content {
        font-size: 18px;
        font-weight: 800;
        color: var(--stat-content-color, #1a1a2e);
        transition: color 0.3s ease;

        .ant-statistic-content-prefix {
          font-size: 15px;
          margin-right: 2px;
        }
      }
    }
  }

  .gauge-footer {
    text-align: left;

    .notice-text {
      font-size: 14px;
      line-height: 1.4;
      font-weight: 600;
      color: #8c8c8c;
      display: flex;
      align-items: flex-start;
      margin-bottom: 6px;

      .detail-bullet {
        font-size: 12px;
        color: #1a1a2e;
        margin-right: 8px;
        margin-top: 3px;
        opacity: 0.7;
      }
    }

    .rule-text {
      font-size: 14px;
      line-height: 1.5;
      font-weight: 600;
    }
  }
}

/* ── Account Balance ── */
/* ── Account & Access Card ── */
.account-card {
  height: 100%;
}

/* ── Leave Card Footer ── */
.leave-card-footer {
  border-top: 1px solid #f0f0f0;

  .text-muted {
    font-size: 11px;
    line-height: 1.4;
    color: #8c8c8c;
    display: block;
  }
}

.d-block {
  display: block;
}

.ml-5 {
  margin-left: 5px;
}

.mb-5 {
  margin-bottom: 5px;
}

/* ── Refined Dashboard Styles (Consolidated) ── */
.mr-15 {
  margin-right: 15px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.ml-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.gap-8 {
  gap: 8px !important;
}

.width-100 {
  width: 100% !important;
}

.normal-weight {
  font-weight: 400 !important;
}

.secondary-text {
  font-size: 14px !important;
  color: #8c8c8c !important;
  font-weight: 600 !important;
}

.header-main-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.flex-start-center {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 100%;
}

.flex-between-center {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100%;
}
</style>
